export class ApplicationError extends Error {
  public readonly name: string;

  constructor(name: string, message: string) {
    super(message);
    this.name = name;
    Object.setPrototypeOf(this, ApplicationError.prototype);
  }
}

export class ValidationError extends Error {
  public readonly errors: Record<string, string>;

  constructor(errors: Record<string, string>) {
    super('VALIDATION_ERROR');
    this.errors = errors;
    Object.setPrototypeOf(this, ValidationError.prototype);
  }
}

export class ParsingDataError extends ApplicationError {
  constructor() {
    super('Error', 'PARSING_ERROR');
  }
}

export class NetworkError extends ApplicationError {
  constructor() {
    super('Jaringan Terputus', 'NETWORK_ERROR');
  }
}
